import React from "react";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function QueryWidgetSettingsMissingQueryInfoAlert(): React.JSX.Element {
  const { i18n } = useTranslation();

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      {i18n.t("widget-settings.widget-query-options.no-query-available")}
    </Alert>
  )
}